var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnfollow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 203,
    viewBox: "0 0 229 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2881_4018",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 37,
    width: 130,
    height: 130
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 167C149.899 167 179 137.899 179 102C179 66.1015 149.899 37 114 37C78.1015 37 49 66.1015 49 102C49 137.899 78.1015 167 114 167Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2881_4018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114 167C149.899 167 179 137.899 179 102C179 66.1015 149.899 37 114 37C78.1015 37 49 66.1015 49 102C49 137.899 78.1015 167 114 167Z",
    fill: "#DDE5E9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.653 37C182.686 37 190.818 44.9368 190.818 54.7273C190.818 55.2 190.8 55.6683 190.762 56.1317C196.997 58.9397 201.324 65.0946 201.324 72.2357C201.324 82.0262 193.191 89.963 183.159 89.963C177.661 89.963 172.733 87.5794 169.402 83.8135C166.224 87.9601 160.44 89.963 153.832 89.963C145.391 89.963 138.294 86.6946 136.256 79.8642C135.917 79.885 135.574 79.8956 135.229 79.8956C126.527 79.8956 119.472 73.1347 119.472 64.7946C119.472 56.4546 126.527 49.6936 135.229 49.6936C135.25 49.6936 135.271 49.6936 135.292 49.6937C135.974 42.5738 142.153 37 149.674 37C153.934 37 157.764 38.7888 160.408 41.6341C163.637 38.7557 167.935 37 172.653 37Z",
    fill: "url(#paint0_linear_2881_4018)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7457 42.6902C83.0032 42.6902 87.2653 46.8496 87.2653 51.9804C87.2653 52.2282 87.2554 52.4737 87.2359 52.7166C90.503 54.1878 92.7706 57.4134 92.7706 61.1559C92.7706 66.2868 88.5085 70.4462 83.251 70.4462C80.3696 70.4462 77.7872 69.1969 76.0415 67.223C74.3762 69.3965 71.345 70.4462 67.882 70.4462C63.4579 70.4462 59.7387 68.7331 58.6707 65.153C58.4931 65.1647 58.3137 65.1702 58.133 65.1702C53.5722 65.1702 49.875 61.6271 49.875 57.2563C49.875 52.8856 53.5722 49.3424 58.133 49.3424C58.144 49.3424 58.1551 49.3425 58.1662 49.3425C58.5234 45.6113 61.7613 42.6902 65.7028 42.6902C67.9355 42.6902 69.9425 43.6275 71.328 45.1185C73.0206 43.6102 75.273 42.6902 77.7457 42.6902Z",
    fill: "url(#paint1_linear_2881_4018)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.505 103.096C149.376 102.928 128.772 117.353 117.413 120.848C109.388 123.317 93.6916 126.253 70.3246 129.655C114.424 149.848 147.762 159.871 170.339 159.724C192.916 159.577 206.016 145.453 209.641 117.353C193.166 107.955 179.121 103.203 167.505 103.096Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.679 133.042C148.064 192.856 116.208 222.763 91.1113 222.763C66.0147 222.763 31.7358 191.371 -11.7255 128.588C7.19598 114.968 27.4981 104.836 49.181 98.1917C73.0837 90.8671 92.1798 108.905 131.74 126.292C142.278 130.923 160.59 133.173 186.679 133.042Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3683 129.973C95.4994 130.388 101.202 129.955 104.477 128.674C111.135 125.609 118.068 102.886 119.147 99.5833C118.332 97.5742 116.722 96.5923 114.317 96.6374C106.745 111.468 101.686 118.763 99.1375 118.523C96.5893 118.284 92.3289 116.959 86.3563 114.549C84.7465 116.59 83.9908 118.544 84.089 120.409C84.1873 122.275 85.2803 125.463 87.3683 129.973Z",
    fill: "#BDBEC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.203 90.0311L114.344 88.8602C114.585 88.8349 114.8 89.0095 114.826 89.2502L115.793 98.4533C115.818 98.694 115.644 98.9096 115.403 98.9349L104.262 100.106C104.022 100.131 103.806 99.9565 103.781 99.7159L102.813 90.5127C102.788 90.272 102.963 90.0564 103.203 90.0311Z",
    fill: "url(#paint2_linear_2881_4018)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.808 88.1342L128.273 86.719C128.514 86.6937 128.73 86.8683 128.755 87.109L129.919 98.1848C129.944 98.4255 129.77 98.6411 129.529 98.6664L116.064 100.082C115.823 100.107 115.607 99.9324 115.582 99.6917L114.418 88.6159C114.393 88.3752 114.567 88.1595 114.808 88.1342Z",
    fill: "#7C8A9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.827 87.1372L129.68 85.6812C129.921 85.6559 130.137 85.8305 130.162 86.0712L131.455 98.3742C131.48 98.6149 131.306 98.8306 131.065 98.8558L117.212 100.312C116.971 100.337 116.756 100.163 116.731 99.9219L115.437 87.6188C115.412 87.3781 115.587 87.1625 115.827 87.1372Z",
    fill: "url(#paint3_linear_2881_4018)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.912 85.1771L147.64 83.3138C147.881 83.2885 148.097 83.4631 148.122 83.7038L149.56 97.3821C149.585 97.6228 149.41 97.8384 149.17 97.8637L131.442 99.727C131.201 99.7523 130.985 99.5777 130.96 99.337L129.522 85.6587C129.497 85.418 129.672 85.2024 129.912 85.1771Z",
    fill: "#7C8A9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.164 83.9581L149.02 82.0814C149.206 82.0619 149.383 82.1621 149.463 82.3311C150.609 84.7752 151.322 87.3353 151.604 90.0113C151.885 92.6881 151.721 95.3571 151.111 98.0183C151.069 98.2008 150.916 98.3366 150.729 98.3562L132.875 100.233C132.634 100.258 132.419 100.083 132.393 99.8427L130.774 84.4397C130.749 84.199 130.924 83.9834 131.164 83.9581Z",
    fill: "url(#paint4_linear_2881_4018)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2299 106.885L89.7701 110.891C89.928 113.727 90.5514 116.556 91.6401 119.378C92.3474 123.389 92.5549 126.008 92.2626 127.235L85.1642 128.486C82.2028 124.795 80.4668 121.502 79.9562 118.606C80.4845 115.956 80.9091 112.049 81.2299 106.885Z",
    fill: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2354 115.366C89.835 115.056 94.1903 117.466 96.37 121.529C98.2908 125.108 99.4634 128.131 99.8879 130.598C101.204 138.247 100.361 139.02 100.361 148.318C100.361 154.516 101.061 164.792 102.46 179.146C98.6753 180.56 93.4915 181.267 86.9082 181.267C80.3248 181.267 73.7415 179.689 67.1582 176.534C71.023 167.234 73.3138 159.997 74.0307 154.823C74.5849 150.822 76.4107 148.044 76.4333 134.304C76.4374 131.836 76.7113 128.079 77.2551 123.032C77.7027 118.879 81.0675 115.646 85.2354 115.366Z",
    fill: "url(#paint5_linear_2881_4018)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.436 103.754C131.358 102.058 132.747 100.33 133.605 98.5706C134.891 95.9319 131.792 92.3547 129.436 93.157C128.163 93.5907 127.538 95.4139 126.478 97.5224C125.838 98.7961 124.183 100.69 124.458 101.698C124.893 103.294 126.553 103.979 129.436 103.754Z",
    fill: "url(#paint6_linear_2881_4018)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6906 133.942C99.7719 135.368 106.227 135.555 110.055 134.503C117.893 131.847 128.359 107.15 129.961 103.569C129.283 101.217 127.591 99.9241 124.884 99.6909C114.633 115.45 108.09 123.045 105.257 122.475C102.424 121.905 97.7967 119.914 91.3747 116.503C89.3262 118.605 88.247 120.71 88.1371 122.816C88.0272 124.923 88.8784 128.632 90.6906 133.942Z",
    fill: "url(#paint7_linear_2881_4018)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7224 111.21C98.3459 111.21 99.336 108.094 99.6927 101.863L102.613 100.88C100.089 97.7768 98.7823 95.1851 98.6929 93.1052C98.5589 89.9855 96.1426 86.0952 94.9259 84.9637C89.202 79.6406 80.1384 80.1928 74.8976 86.0134C69.6567 91.8339 70.1267 100.801 75.9472 106.042C78.6273 108.455 81.9198 109.719 85.4285 110.415C89.5201 111.227 93.0489 111.21 96.7224 111.21Z",
    fill: "#FFEFE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6978 76.1758L77.7262 76.1174C78.1684 75.2559 79.0797 74.6806 80.1115 74.7166C81.5347 74.7663 82.6482 75.9603 82.5985 77.3835L82.4511 81.6058C86.7801 80.6443 91.4733 81.706 94.9262 84.9636C95.7916 86.0133 96.4101 86.4359 97.2859 87.9659C96.0299 89.8898 92.5395 94.0439 88.8127 96.3964C88.0344 96.8878 87.2933 96.7063 86.5405 96.4909L86.2453 96.4063C85.2914 96.1373 84.3088 95.9468 83.1997 97.1156C82.6685 97.5767 81.788 99.2072 82.2405 103.928C82.3934 105.524 82.155 107.388 81.1593 109.481C79.1444 108.608 77.1092 107.03 75.9475 106.042C72.5425 102.976 70.9686 98.6347 71.2979 94.3943L66.8531 95.6692C65.4842 96.0617 64.0563 95.2702 63.6638 93.9013C63.3964 92.969 63.6784 92.0092 64.3179 91.3679C63.538 90.9942 62.964 90.2355 62.8669 89.3114C62.7596 88.2911 63.2628 87.3474 64.0821 86.8438C63.4052 86.215 63.09 85.2416 63.3459 84.2866C63.5768 83.425 64.2178 82.7828 65.0026 82.5138C64.5903 81.6941 64.6303 80.6799 65.1936 79.8754C65.8496 78.9386 67.0158 78.5713 68.0539 78.8861C67.9587 77.9846 68.3436 77.06 69.1389 76.5031C70.2959 75.693 71.8869 75.9652 72.7098 77.1077C72.7022 75.9105 73.5348 74.8319 74.7523 74.5731C76.0127 74.3052 77.2537 75.0077 77.6978 76.1758Z",
    fill: "url(#paint8_linear_2881_4018)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2881_4018",
    x1: 160.398,
    y1: 55.8935,
    x2: 160.398,
    y2: 89.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.158486
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2881_4018",
    x1: 71.3228,
    y1: 52.5916,
    x2: 71.3228,
    y2: 70.4462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.158486
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2881_4018",
    x1: 111.471,
    y1: 89.2161,
    x2: 110.454,
    y2: 98.1154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8897A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2881_4018",
    x1: 125.966,
    y1: 85.2324,
    x2: 124.645,
    y2: 98.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8897A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2881_4018",
    x1: 145.286,
    y1: 83.0559,
    x2: 143.641,
    y2: 96.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8897A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2881_4018",
    x1: 84.8089,
    y1: 115.339,
    x2: 84.8089,
    y2: 181.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2881_4018",
    x1: 128.895,
    y1: 92.2643,
    x2: 126.611,
    y2: 102.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2881_4018",
    x1: 128.607,
    y1: 101.757,
    x2: 89.8992,
    y2: 119.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDDE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C7D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2881_4018",
    x1: 67.6605,
    y1: 80.3006,
    x2: 85.2214,
    y2: 104.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DDDD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollow);
export default __webpack_public_path__ + "static/media/unfollow.0cc743f2.svg";
export { ForwardRef as ReactComponent };